module.exports = __webpack_public_path__ + "static/media/pile.0ef5c5f8.gif";